module.exports = __webpack_public_path__ + "static/media/event.43f9528f.png";